var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNashik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2630,
    height: 1767,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-885 -363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2971.34 1255.22C3172.9 1742.48 2762.58 2049.92 2268.12 2049.92 1773.66 2049.92 1372.79 1694.14 1372.79 1255.22 1372.79 816.295 1771.56 423.918 2265.99 423.918 2760.42 423.918 2939.69 629.222 2971.34 1255.22",
    fill: "#EBF2FC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2111.5 895.5 2111.5 805.095C2111.5 792.613 2121.49 782.5 2133.83 782.5L2223.17 782.5C2235.51 782.5 2245.5 792.613 2245.5 805.095L2245.5 876.659",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.5 1836.5 3102.5 1836.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2133.5 573.5 2133.5 487.5 2218.5 487.5 2218.5 573.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155.5 487.5 2155.5 419.994C2155.5 407.567 2165.57 397.5 2178 397.5L2178 397.5C2190.43 397.5 2200.5 407.567 2200.5 419.994L2200.5 487.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2181.4 874.5C1768.25 874.5 1461.53 1124.7 1364.5 1244.5L2979.5 1244.5C2888.74 1124.7 2594.53 874.5 2181.4 874.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3007.73 1413.81C2962.65 1413.81 2960.78 1487.78 2970.18 1519.48L3026.5 1836.5 2951.4 1836.5 2895.08 1519.48C2891.95 1480.73 2874.43 1403.24 2829.36 1403.24 2784.28 1403.24 2785.53 1466.64 2791.81 1498.34L2829.36 1836.5 2754.26 1836.5C2741.73 1773.1 2712.93 1627.26 2697.93 1551.18 2679.16 1456.07 2660.38 1382.08 2585.26 1382.08 2528.94 1382.08 2525.79 1494.8 2528.94 1551.18L2528.94 1836.5 2453.84 1836.5C2450.72 1797.76 2442.57 1686.43 2435.07 1551.18 2427.54 1415.92 2344.32 1382.08 2303.62 1382.08 2175.93 1365.18 2150.28 1487.75 2153.4 1551.18L2153.4 1836.5 2078.3 1836.5 2078.3 1551.18C2081.43 1494.82 2065.15 1382.08 1975.03 1382.08 1884.91 1382.08 1849.86 1473.66 1843.59 1519.45L1806.04 1836.48 1740.32 1836.48 1749.71 1519.45C1746.59 1473.66 1759.11 1382.08 1674.62 1382.08 1618.29 1382.08 1590.12 1459.57 1580.72 1498.32L1515 1836.48 1458.67 1836.48C1477.45 1720.24 1515 1489.87 1515 1456.05 1515 1422.24 1505.6 1405.33 1496.22 1403.22 1458.67 1394.76 1443.02 1434.92 1439.9 1456.05L1355.4 1836.48 1308.5 1836.48",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3195.72 1932.5C3176.95 1879.58 3139.39 1879.58 3101.81 1879.58L2998.53 1371.51C3101.81 1360.92 3183.2 1286.84 3214.5 1244.5L1167.5 1244.5C1205.05 1312.24 1274.91 1347.7 1383.47 1360.92L1289.56 1879.58C1236.98 1879.58 1217.58 1914.86 1214.45 1932.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.5 1977.5C1129.5 1952.64 1149.47 1932.5 1174.12 1932.5L3226.88 1932.5C3251.53 1932.5 3271.5 1952.64 3271.5 1977.5L3271.5 1977.5C3271.5 2002.36 3251.53 2022.5 3226.88 2022.5L1174.14 2022.5C1149.49 2022.5 1129.52 2002.34 1129.52 1977.5L1129.52 1977.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.5 1158.5 2901.5 1158.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.5 1072.5 2790.5 1072.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977.5 895.5 1977.5 714.5 2378.5 714.5 2378.5 887.35",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965.98 646.5 2390.02 646.5C2408.51 646.5 2423.5 661.724 2423.5 680.5L2423.5 680.5C2423.5 699.277 2408.51 714.5 2390.02 714.5L1965.98 714.5C1947.49 714.5 1932.5 699.277 1932.5 680.5L1932.5 680.5C1932.5 661.724 1947.49 646.5 1965.98 646.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030.77 578.5 2325.23 578.5C2342.51 578.5 2356.5 592.593 2356.5 610L2356.5 610C2356.5 627.407 2342.51 641.5 2325.23 641.5L2030.77 641.5C2013.49 641.5 1999.5 627.407 1999.5 610L1999.5 610C1999.5 592.593 2013.49 578.5 2030.77 578.5Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2066.5 488.5 2289.5 488.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNashik);
export default __webpack_public_path__ + "static/media/nashik.41ec4eff9901d2d336b1f0a0ce6850ec.svg";
export { ForwardRef as ReactComponent };